import React from 'react';
import LoginPage from '../../auth/pages/LoginPage';

// Wrapper that passes publisherLogin API to generic LoginPage via context prop override if needed.
// For quick deliverable reuse existing LoginPage component; it internally calls authAPI.login.
// We monkey-patch authAPI.login to call publisherLogin during this render.

import { authAPI } from '../../../utils/api';

function PublisherLoginPage(props) {
  // Temporarily reroute login API
  const originalLogin = authAPI.login;
  authAPI.login = authAPI.publisherLogin;
  React.useEffect(() => () => { authAPI.login = originalLogin; }, []);
  return <LoginPage {...props} redirectPath="/publisher/dashboard" />;
}

export default PublisherLoginPage;
